import gsap from "gsap";

const inners = document.querySelectorAll(".marquee__inner");
if (inners.length) {
  gsap.to(inners, {
    x: "-100%",
    duration: 10,
    repeat: -1,
    ease: "none",
  });
}
